const DefectIcon = () => {
	return (
		<svg
			width="30"
			height="29"
			viewBox="0 0 30 29"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<rect width="30" height="29" fill="url(#pattern0_1293_2055)" />
			<defs>
				<pattern
					id="pattern0_1293_2055"
					patternContentUnits="objectBoundingBox"
					width="1"
					height="1"
				>
					<use
						xlinkHref="#image0_1293_2055"
						transform="matrix(0.0193333 0 0 0.02 0.0166667 0)"
					/>
				</pattern>
				<image
					id="image0_1293_2055"
					width="50"
					height="50"
					preserveAspectRatio="none"
					xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAABFElEQVR4nO3ZPWrDQBRF4dlNCnsP+VmAO7cpU0SbCFlEjEDBlV1lBQ7GazAIvAcX7lyfYFAxvMJSxiLzpNwDaoQ0vA8hGKQQlFJq8AF3wALYAN9Ojg3wcZmtK2IKnPHbGZh0gazx36oLZI//9l0gtbmpBF4yH6WZqU6BzEPmgLkgY4SUY3lHPFYLMkRI1extTubmQ4b91cHMcGrOV62QCLQzixThjwMKM8MuZRFB+gpBogTpMQSJEqTHECRKkP8AAb5aNokzc/2rV8iR6xVDeSKCeIM8t3xkmAziHUmYoRBkjJCtWWSd4cPcysywTYEs8ddnCuQJfz38GtJg3vHTWxIiwjxeHmnGn6AVcH8TQimlgrd+AF3LFXaGPx1lAAAAAElFTkSuQmCC"
				/>
			</defs>
		</svg>
	);
};

export default DefectIcon;